import React from 'react'
import { Form } from 'antd';
import { Grid, TextField, Checkbox, FormControlLabel,Snackbar } from '@material-ui/core';
import MySnackbarContentWrapper from "../../../components/SnackBar";

class siteForm extends React.Component {
  
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    serviceNewsletter: this.props.services && this.props.services.filter(e => e.name === "Newsletter")[0] ? this.props.services.filter(e => e.name === "Newsletter")[0].enabled: false,
    servicePlacements: this.props.services && this.props.services.filter(e => e.name === "Placements")[0] ? this.props.services.filter(e => e.name === "Placements")[0].enabled: false,
    servicePush: this.props.services && this.props.services.filter(e => e.name === "BrowserNotification")[0] ? this.props.services.filter(e => e.name === "BrowserNotification")[0].enabled: false,
    snackOpen : false,
    snackType: "info",
    snackMessage: "Action executing..."
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open,type,message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ snackOpen: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const services = [
        { enabled: this.state.serviceNewsletter, name: "Newsletter"},
        { enabled: this.state.servicePlacements, name: "Placements"},
        { enabled: this.state.servicePush, name: "BrowserNotification"}];

        this.props.query_f({ variables: { id: this.props.id, domain: values.domain, initial: values.initial, name: values.name, userId: values.userId, services: services, percentual:parseFloat(values.percentual) } }).then(result =>{
          this.setStateValues(true,"success","Action executed with success!");
          this.props.form.resetFields();
          if(this.props.onCancel){
            this.props.onCancel();
          }
          localStorage.setItem('adireto-drawer-open', false);
        }, error=>{
          this.setStateValues(true,"error","Action executed with error!");          
        });
      }
      else{
        this.setStateValues(true,"error","Form validation failed!");  
      }
    });
  }

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  handleChangeServiceNewsletter = (event) => {
    this.setState({ serviceNewsletter: event.target.checked });
  };

  handleChangeServicePlacements= (event) => {
    this.setState({ servicePlacements: event.target.checked });
  };
  
  handleChangeServicePush= (event) => {
    this.setState({ servicePush: event.target.checked });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <form id="myForm" onSubmit={this.handleSubmit}>
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }} open={this.state.snackOpen} autoHideDuration={6000} onClose={this.handleClose}>
          <MySnackbarContentWrapper onClose={this.handleClose} variant={this.state.snackType} message={this.state.snackMessage}/>
        </Snackbar>
        <Grid container spacing={0}>
        <Grid item xs={12}>
          {getFieldDecorator('domain', {
            initialValue: (this.props.domain || ''),
            rules: [{ required: true, message: 'Please input your domain!', whitespace: true }],
          })(
            <TextField
                  id="domain"
                  label="domain"
                  color="primary"
                  fullWidth
                  style={{ marginTop : 13 }}
                  InputLabelProps={{
                    shrink : true,
                  }}
                  placeholder="domain"
                />
          )}
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('name',
           {
            initialValue: (this.props.name || ''),
            rules: [{ required: true, message: 'Please input your name!', whitespace: true }],
          })(
            <TextField
                  id="name"
                  label="name"
                  color="primary"
                  fullWidth
                  style={{ marginTop : 13 }}
                  InputLabelProps={{
                    shrink : true,
                  }}
                  placeholder="name"
                />
          )}
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('initial',
           {
            initialValue: (this.props.initial || ''),
            rules: [{ required: true, message: 'Please input the initial!', whitespace: false }],
          })(
            <TextField
                  id="initial"
                  label="initial"
                  color="primary"
                  fullWidth
                  style={{ marginTop : 13 }}
                  InputLabelProps={{
                    shrink : true,
                  }}
                  placeholder=""
                />
          )}
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('percentual',
           {
            initialValue: (this.props.percentual || "85"),
            rules: [{ required: true, message: 'Please input the revenue share!', whitespace: false }],
          })(
            <TextField
                  id="percentual"
                  label="Revenue Share"
                  color="primary"
                  fullWidth
                  style={{ marginTop : 13 }}
                  InputLabelProps={{
                    shrink : true,
                  }}
                  placeholder="Revenue share"
                />
          )}
        </Grid>

        <Grid item xs={12}>
          {getFieldDecorator('serviceNewsletter', { initialValue: (this.state.serviceNewsletter || ''), rules: [{ required: false }],})(
            <>
              <FormControlLabel
                control={
                  <Checkbox id="isServiceNewsletter"
                    checked={this.state.serviceNewsletter}
                    value={this.state.serviceNewsletter}
                    onChange = {this.handleChangeServiceNewsletter}
                    inputProps={{
                      'aria-label': 'primary checkbox',
                    }}
                  />
                }
                style={{marginTop : 10}}
                label="Newsletter" />
              </>
          )}
        </Grid>

        <Grid item xs={12}>
          {getFieldDecorator('servicePlacements', { initialValue: (this.state.servicePlacements || ''), rules: [{ required: false }],})(
            <>
              <FormControlLabel
                control={
                  <Checkbox id="isServicePlacements"
                    checked={this.state.servicePlacements}
                    value={this.state.servicePlacements}
                    onChange = {this.handleChangeServicePlacements}
                    inputProps={{
                      'aria-label': 'primary checkbox',
                    }}
                  />
                }
                style={{marginTop : 10}}
                label="Placements" />
              </>
          )}
        </Grid>

        
        <Grid item xs={12}>
          {getFieldDecorator('servicePush', { initialValue: (this.state.servicePush || ''), rules: [{ required: false }],})(
            <>
              <FormControlLabel
                control={
                  <Checkbox id="isServicePush"
                    checked={this.state.servicePush}
                    value={this.state.servicePush}
                    onChange = {this.handleChangeServicePush}
                    inputProps={{
                      'aria-label': 'primary checkbox',
                    }}
                  />
                }
                style={{marginTop : 10}}
                label="Browser Notification" />
              </>
          )}
        </Grid>

        </Grid>
        </form>
    );
  }
}

const sitesForm = Form.create()(siteForm);

export default sitesForm